import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NbIconLibraries, NbMediaBreakpoint, NbThemeModule, NbJSThemeOptions, NbThemeOptions } from '@nebular/theme';

export enum ThemeType {
  Default = 'default',
  Blue = 'blue',
  Cyan = 'cyan',
  Pear = 'pear',
  Violet = 'electric violet',
  Party = 'party',
}

export const THEMES = new Map<ThemeType, string>([
  [ThemeType.Default, 'dark'],
  [ThemeType.Blue, ThemeType.Blue],
  [ThemeType.Cyan, ThemeType.Cyan],
  [ThemeType.Pear, ThemeType.Pear],
  [ThemeType.Violet, 'electric-violet'],
  [ThemeType.Party, ThemeType.Party],
]);

export enum EBreakpoint {
  XS = 0,
  IS = 400,
  SM = 576,
  MD = 768,
  LG = 1024,
  XL = 1200,
  XXL = 1400,
  XXXL = 1600,
}
export const DEFAULT_THEME_OPTIONS: NbThemeOptions = { name: 'dark' };
export const DEFAULT_JS_THEME_OPTIONS: NbJSThemeOptions[] | undefined = undefined;
export const DEFAULT_BREAKPOINTS: NbMediaBreakpoint[] = [
  {
    name: 'xs',
    width: EBreakpoint.XS,
  },
  {
    name: 'is',
    width: EBreakpoint.IS,
  },
  {
    name: 'sm',
    width: EBreakpoint.SM,
  },
  {
    name: 'md',
    width: EBreakpoint.MD,
  },
  {
    name: 'lg',
    width: EBreakpoint.LG,
  },
  {
    name: 'xl',
    width: EBreakpoint.XL,
  },
  {
    name: 'xxl',
    width: EBreakpoint.XXL,
  },
  {
    name: 'xxxl',
    width: EBreakpoint.XXXL,
  },
];

@NgModule({
  imports: [CommonModule, NbThemeModule.forRoot(DEFAULT_THEME_OPTIONS, DEFAULT_JS_THEME_OPTIONS, DEFAULT_BREAKPOINTS)],
})
export class ThemeModule {
  constructor(private iconLibraries: NbIconLibraries) {
    this.iconLibraries.registerFontPack('uiverse-icons', { packClass: 'si', iconClassPrefix: 'si' });
    this.iconLibraries.setDefaultPack('uiverse-icons');
  }
}
